<script lang="ts">import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import Modal from "../modal.svelte";
let { open = false, url = null, onClose = () => {}, title = null, iframeTitle = "Embedded content", width = "850px", maxWidth = "100vw", maxHeight = "94vh", maxHeightContent = "none", padding = "1rem", zIndexOverlay = 12e3, zIndexUnderlay = 11999, allow = "payment *; clipboard-write; geolocation; microphone; camera; autoplay; fullscreen; accelerometer; gyroscope; encrypted-media; midi; usb; xr-spatial-tracking", sandbox = "allow-same-origin allow-forms allow-scripts allow-popups allow-modals allow-pointer-lock allow-downloads allow-top-navigation-by-user-activation allow-top-navigation", referrerPolicy = "no-referrer-when-downgrade", onMessage } = $props();
let iframeLoaded = $state(false);
const useMarginTop = $derived($stateUi.iframeModal?.useMarginTop ?? false);
const iframeLoading = $derived(!!url && open && !iframeLoaded);
$effect(() => {
	if (!open || !url) iframeLoaded = false;
});
$effect(() => {
	const handleMessage = (event) => {
		if (!open || !onMessage) return;
		onMessage(event);
	};
	window.addEventListener("message", handleMessage);
	return () => window.removeEventListener("message", handleMessage);
});
</script>

{#if open}
	<Modal
		scrollDisabled={false}
		closeModal={onClose}
		{width}
		{maxWidth}
		{maxHeight}
		{maxHeightContent}
		{padding}
		{zIndexOverlay}
		{zIndexUnderlay}
		{title}
		showCloseButton={true}
		customStyleContent="overflow-y: hidden; padding: 0;"
	>
		<div
			class="iframe-container"
			style={`--iframe-max-height: ${maxHeight}; ${useMarginTop ? 'margin-top: 2rem;' : ''}`}
		>
			{#if url}
				{#if iframeLoading}
					<div class="iframe-loading">{$t(Verbiage.loading)}...</div>
				{/if}
				<iframe
					class="iframe-frame"
					src={url}
					title={iframeTitle}
					{allow}
					allowfullscreen
					{sandbox}
					referrerpolicy={referrerPolicy}
					onload={() => (iframeLoaded = true)}
				/>
				<div class="iframe-fallback">
					<!-- eslint-disable-next-line svelte/no-navigation-without-resolve -->
					<a href={url} target="_blank" rel="noopener noreferrer">
						{$t(Verbiage.open_in_new_tab)}
					</a>
				</div>
			{:else}
				<div class="iframe-error">
					{$t(Verbiage.something_went_wrong)}
				</div>
			{/if}
		</div>
	</Modal>
{/if}

<style>
	.iframe-container {
		width: 100%;
		padding-bottom: 1rem
}

	.iframe-frame {
		display: block;
		width: 100%;
		border-radius: 0.75rem;
		height: min(calc(var(--iframe-max-height) - 8rem), 800px);
		border: 0
}

	.iframe-loading {
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: center;
		padding-top: 1rem;
		padding-bottom: 1rem;
		text-align: center;
		opacity: 0.8
}

	.iframe-fallback {
		margin-top: 0.75rem;
		text-align: center
}

	.iframe-error {
		width: 100%;
		padding-top: 2rem;
		padding-bottom: 2rem;
		text-align: center;
		opacity: 0.8
}
</style>
